import { useTranslation } from 'react-i18next';
import type { RideListItem } from '../types/api.ts';

/** "View on Strava" for a Strava-sourced ride or activity; nothing otherwise. */
export function StravaLink({
  ride,
}: Readonly<{ ride: Pick<RideListItem, 'source' | 'source_activity_id'> }>) {
  const { t } = useTranslation();
  if (ride.source !== 'strava') return null;
  return (
    <a
      href={`https://www.strava.com/activities/${ride.source_activity_id}`}
      target="_blank"
      rel="noreferrer"
      className="self-start text-sm text-(--color-accent) hover:underline"
    >
      {t('rideDetail.viewOnStrava')} {'↗'}
    </a>
  );
}
